import { useEffect, useRef } from 'react';
import { PianoEvent } from '../types';

export interface PianoConfig {
  eventHandlers?: Array<((e: PianoEvent) => void) | undefined>;
  postHandlers?: boolean;
  tags?: Array<string>;
  segment: any;
  classesUserSegment: 'classes' | 'canceled_classes' | 'none';
  shouldAutoInit?: boolean;
}

export default function usePiano({
  eventHandlers = [],
  postHandlers,
  tags,
  segment,
  classesUserSegment,
  shouldAutoInit = true,
}: PianoConfig) {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!segment) return;
    window.tp = window.tp || [];

    // set Tags
    if (tags) window.tp.push(['setTags', tags]);

    // set userSegment
    if (segment) {
      window.tp.push(['setCustomVariable', 'userSegment', segment]);
    }

    if (classesUserSegment) {
      window.tp.push([
        'setCustomVariable',
        'classesUserSegment',
        classesUserSegment,
      ]);
    }

    //set Handlers
    if (postHandlers) {
      eventHandlers?.forEach((handler) => {
        if (handler) {
          window.tp.push([
            'addHandler',
            'checkoutCustomEvent',
            (e: PianoEvent) => handler(e),
          ]);
        }
      });
    }

    if (shouldAutoInit && !hasInitialized.current) {
      hasInitialized.current = true;
      window.tp.push([
        'init',
        function initExperience() {
          window.tp.experience.execute();
        },
      ]);
    }
  }, [
    tags,
    eventHandlers,
    segment,
    postHandlers,
    classesUserSegment,
    shouldAutoInit,
  ]);

  const initPiano = () => {
    if (!window.tp || hasInitialized.current) return;

    hasInitialized.current = true;
    window.tp.push([
      'init',
      function initExperience() {
        window.tp.experience.execute();
      },
    ]);
  };

  return initPiano;
}
